import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';

import { EcmDispatcherModule } from '@ecm/dispatcher';
import { Brand, ContextService, Universe } from '@ecm/portfolio';

import { RouterService } from '../services/router.service';
import { PhygitalHelper } from '../utils/phygital-helper';

@Injectable({
    providedIn: 'root',
})
export class PhygitalGuard {
    private static CLASS_NAME = 'PhygitalGuard';

    private SELECTOR_CONTRACT = '/selectionner-un-contrat';

    private REDIRECT_URL_LOGGED = 'https://boutique.orange.fr/mes-avantages/changer-de-mobile';

    private REDIRECT_URL_NOT_LOGGED = 'https://boutique.orange.fr/mobile/details';

    public constructor(
        private readonly contextService: ContextService,
        private readonly routerService: RouterService,
    ) {}

    public canActivate(_activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.contextService.isAuthenticated().pipe(
            map((isAuthenticated) => {
                if (isAuthenticated) {
                    const url = PhygitalHelper.constructRedirectUrl(this.REDIRECT_URL_LOGGED, state?.root?.queryParams);
                    EcmDispatcherModule.sendConsoleInfo(
                        PhygitalGuard.CLASS_NAME,
                        'User is already logged, will let go to route : ' + url,
                    );
                    this.goToContractSelector(url);
                } else {
                    const url = PhygitalHelper.constructRedirectUrl(
                        this.REDIRECT_URL_NOT_LOGGED,
                        state?.root?.queryParams,
                    );
                    EcmDispatcherModule.sendConsoleInfo(
                        PhygitalGuard.CLASS_NAME,
                        'User is not logged, will let go to route : ' + url,
                    );
                    this.routerService.redirectToExternalUrl(url);
                }
                return false;
            }),
        );
    }

    private goToContractSelector(rawReturnUrl: string): void {
        const extras = {
            queryParams: {
                returnUrl: encodeURI(rawReturnUrl),
                universe: [Universe.OPEN, Universe.MOBILE],
                brand: [Brand.ORANGE],
                marketType: ['RES', 'PRO'],
                status: ['ACTIF'],
            },
        };
        this.routerService.navigate([this.SELECTOR_CONTRACT], extras);
    }
}
